<script setup lang="ts">
import { AppConfirmDialog } from '~/components/base';
import { AppFooter, AppTopbar } from '~/components/layout';
</script>

<template>
  <div class="guest-layout">
    <AppTopbar mode="guest" />
    <NuxtPage :page-key="(route) => route.fullPath" />
    <AppFooter />
    <AppConfirmDialog />
  </div>
</template>

<style lang="scss" scoped>
.guest-layout {
  position: relative;
  width: 100%;
  height: 100vh;
}
</style>
